module.exports = __webpack_public_path__ + "img/Oiltanking_South-America_Brazil_Vitoria_Tanks_2015-02-04_5.3e1cd605.jpg";